import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './User/Home';
import AdminHome from './Admin/AdminHome';
import Dashboard from './Admin/Dashboard';
import Contact from './Admin/Contact';
import Notifaction from './Admin/Notifaction';
import Request from './Admin/Request';
import AddNotifaction from './Admin/AddNotifaction';
import UpdateNotifaction from './Admin/UpdateNotifaction';
import AddCategory from './Admin/AddCategory';
import AdminCategory from './Admin/AdminCategory';
import UpdateCategory from './Admin/UpdateCategory';
import Login from './User/Login';
import Signup from './User/Signup';
import SuperAdmin from './Admin/SuperAdmin';
import ForgetPassword from './User/ForgetPassword';
import Admission from './Page/Admission';
import AdmitCard from './Page/AdmitCard';
import AnswerKey from './Page/AnswerKey';
import CurrentJob from './Page/CurrentJob';
import UserPage from './Admin/UserPage';
import UserProfiile from './Admin/UserProfiile';
import Document from './Page/Document';
import Important from './Page/Important';
import LatestBlog from './Page/LatestBlog';
import Result from './Page/Result';
import NewUpdate from './Page/NewUpdate';
import SarkariYojna from './Page/SarkariYojana';
import Scholarship from './Page/Scholarship';
import Syllabus from './Page/Syllabus';
import UniversityUpdate from './Page/UniversityUpdate';
import UpcomingJob from './Page/UpcomingJob';
import ContactFloat from './Page/ContactFloat';
import ContactView from './Admin/ContactView';
import NotifactionView from './Page/NotifactionView';
import ContactUser from './User/ContactUser';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/AdminHome' element={<AdminHome />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/addcategory' element={<AddCategory />} />
        <Route path='/notifaction' element={<Notifaction />} />
        <Route path='/request' element={<Request />} />
        <Route path='/addnotifaction' element={<AddNotifaction />} />
        <Route path='/updatenotifaction/:_id' element={<UpdateNotifaction />} />
        <Route path='/admincategory' element={<AdminCategory />} />
        <Route path='/updatecategory/:_id' element={<UpdateCategory />} />
        <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<Signup />} />
        <Route path='/superadmin' element={<SuperAdmin />} />
        <Route path='/forgetpassword' element={<ForgetPassword />} />
        <Route path='/admission' element={<Admission />} />
        <Route path='/admitcard' element={<AdmitCard />} />
        <Route path='/answerkey' element={<AnswerKey />} />
        <Route path='/latestjob' element={<CurrentJob />} />
        <Route path='/userpage' element={<UserPage />} />
        <Route path='/userprofile/:_id' element={<UserProfiile />} />
        <Route path='/document' element={<Document />} />
        <Route path='/important' element={<Important />} />
        <Route path='/latestblog' element={<LatestBlog />} />
        <Route path='/newupdate' element={<NewUpdate />} />
        <Route path='/result' element={<Result />} />
        <Route path='/sarkariyojna' element={<SarkariYojna />} />
        <Route path='/scholarship' element={<Scholarship />} />
        <Route path='/universityUpdate' element={<UniversityUpdate />} />
        <Route path='/syllabus' element={<Syllabus />} />
        <Route path='/upcomingjob' element={<UpcomingJob />} />
        <Route path='/contactview/:_id' element={<ContactView />} />
        <Route path="/notifactionview/:_id" element={<NotifactionView />} />
        <Route path="/contactuser" element={<ContactUser />} />
      </Routes>
      <ContactFloat page="home" />
    </BrowserRouter>
    
  );
}

export default App;